import slider from "../components/slider";

slider("hero-slider", {
    type: "carousel",
    startAt: 0,
    perView: 1,
    autoplay: 5000
});